import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminTestimonialAdd from "../../../../views/admin/cms/testimonials/AdminTestimonialAdd";

const AdminTestimonialAddPage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminTestimonialAdd />
      <AdminFooter />
    </div>
  );
};

export default AdminTestimonialAddPage;
